import React from 'react';
import { Box, Typography } from '@mui/material';
import { DonutChart } from '../../../shared';
import { NPI_SEGMENT_CHART_OPTIONS } from './constants';
import { useSelector } from 'react-redux';
import DonutChartSkeleton from '../../../shared/skelton/donutChartSkeleton';

function NpiEngagedPieChart() {
    const { isLoading, NpiEngagedChart } = useSelector((state) => state.totalEngagement);
    const {
        labels,series,colors 
    } = NpiEngagedChart;
    
    return (
        <Box className='container-p-24-br-16 bg-gray-50 height-100'>
            <Box>
                <Typography className='text-md-semi-bold gray-900' >
                    No. of Engagements
                </Typography>
            </Box>
            <Box className="wh-70 align_center" id="total-engagement-segments">
                {
                    isLoading 
                        ? <DonutChartSkeleton/> 
                        : <DonutChart
                            chartOptions={{
                                ...NPI_SEGMENT_CHART_OPTIONS, labels: labels, colors: colors 
                            }}
                            chartSeries={series}
                            isCount={true}
                        />
                }
            </Box>
        </Box>
    );
}

export default NpiEngagedPieChart;
